/* Aesthetics Brothers: bebidas en 12 pack se venden de 2 en 2.
   El proveedor surte los 12 pack en múltiplos de 2 (2 doce-packs llenan una caja),
   y se pueden combinar marcas y sabores.
   - Qué productos cuentan: los que tienen la etiqueta "caja-2" (colección caja-de-2).
     theme.liquid los pasa en window.AB_CAJA2. Para agregar uno nuevo, ponle la etiqueta.
   1) En la ficha de esos productos muestra un aviso arriba del botón de compra.
   2) En el carrito muestra cuántos 12 pack lleva y cuántos faltan para completar la caja.
   3) Bloquea el paso al checkout si el total de 12 pack es impar.
   Para desactivar todo, quita la línea que carga este archivo en layout/theme.liquid. */
(function(){
  var IDS = (window.AB_CAJA2 || []).map(String);
  if (!IDS.length) return;
  var cajas = 0; /* último conteo de 12 pack en el carrito */
  var URL_CAJA = '/collections/caja-de-2';

  function esCaja(productId){ return IDS.indexOf(String(productId)) > -1; }

  function fetchCajas(){
    return fetch('/cart.js', {credentials: 'same-origin', cache: 'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (!c || !c.items) return null;
        var n = 0;
        for (var i = 0; i < c.items.length; i++){
          if (esCaja(c.items[i].product_id)) n += c.items[i].quantity || 0;
        }
        return n;
      })
      .catch(function(){ return null; });
  }

  function cumple(n){ return n === null || n % 2 === 0; }

  function textoCarrito(n){
    if (n % 2 === 0) return 'Llevas ' + n + ' doce-packs de bebida: ' + (n / 2) + (n === 2 ? ' caja completa.' : ' cajas completas.');
    return 'Llevas ' + n + (n === 1 ? ' doce-pack' : ' doce-packs') + ' de bebida. Se envían de 2 en 2 porque 2 llenan una caja: agrega 1 más de cualquier marca o sabor, o quita 1.';
  }

  /* ---------- Aviso en la ficha ---------- */
  function avisoFicha(){
    if (location.pathname.indexOf('/products/') === -1) return;
    fetch(location.pathname.replace(/\/$/, '') + '.js', {credentials: 'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(p){
        if (!p || !esCaja(p.id) || document.getElementById('ab-caja2-ficha')) return;
        var anchor = document.querySelector('.product-block--price') || document.querySelector('form[action*="/cart/add"]');
        if (!anchor) return;
        var box = document.createElement('div');
        box.id = 'ab-caja2-ficha';
        box.style.cssText = 'margin:14px 0;padding:12px 14px;border:1px solid #d40000;border-radius:12px;background:#1a0b0b;color:#fff;font-size:14px;line-height:1.45;max-width:420px;';
        box.innerHTML = '<div style="font-weight:800;margin-bottom:4px;">Se envía de 2 en 2</div>' +
          'Los 12 pack de bebida viajan en caja de 2. Agrega otro 12 pack de la misma u otra marca, del sabor que quieras. ' +
          '<a href="' + URL_CAJA + '" style="color:#ff6b6b;font-weight:700;text-decoration:underline;">Ver bebidas en 12 pack</a>';
        if (anchor.tagName === 'FORM') anchor.insertAdjacentElement('beforebegin', box);
        else anchor.insertAdjacentElement('afterend', box);
      })
      .catch(function(){});
  }

  /* ---------- Aviso en el carrito (página y carrito lateral) ---------- */
  function contenedoresCarrito(){
    var out = [];
    var forms = document.querySelectorAll('form[action*="/cart"]');
    for (var i = 0; i < forms.length; i++){
      if (forms[i].querySelector('[name="checkout"]')) out.push(forms[i]);
    }
    return out;
  }

  function refrescarCarrito(){
    var cs = contenedoresCarrito();
    if (!cs.length) return;
    fetchCajas().then(function(n){
      if (n !== null) cajas = n;
      for (var i = 0; i < cs.length; i++){
        var f = cs[i];
        var box = f.querySelector('.ab-caja2-cart');
        if (!n){ if (box) box.remove(); continue; }
        if (!box){
          box = document.createElement('div');
          box.className = 'ab-caja2-cart';
          f.insertBefore(box, f.firstChild);
        }
        var ok = n % 2 === 0;
        box.style.cssText = 'margin:0 0 12px;padding:10px 12px;border-radius:10px;font-size:13px;line-height:1.4;font-weight:600;' +
          (ok ? 'background:#0f2416;color:#bff0cf;border:1px solid #1f6b3a;' : 'background:#2a0d0d;color:#fff;border:1px solid #d40000;');
        box.textContent = textoCarrito(n);
        if (!ok){
          var a = document.createElement('a');
          a.href = URL_CAJA;
          a.textContent = ' Ver bebidas en 12 pack';
          a.style.cssText = 'color:#ff6b6b;text-decoration:underline;';
          box.appendChild(a);
        }
      }
    });
  }

  function refreshSoon(delay){
    clearTimeout(refreshSoon._t);
    refreshSoon._t = setTimeout(refrescarCarrito, delay || 500);
  }

  /* ---------- Bloqueo de checkout ---------- */
  function isCheckoutEl(el){
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    if (tag !== 'BUTTON' && tag !== 'A' && tag !== 'INPUT') return false;
    var name = (el.getAttribute('name') || '').toLowerCase();
    var href = (el.getAttribute('href') || '').toLowerCase();
    var cls = (typeof el.className === 'string' ? el.className : '').toLowerCase();
    var id = (el.id || '').toLowerCase();
    if (name === 'checkout') return true;
    if (tag === 'A' && /\/checkout(\/|\?|#|$)/.test(href)) return true;
    if (cls.indexOf('checkout') > -1 || id.indexOf('checkout') > -1) return true;
    return false;
  }

  function showMsg(n){
    var box = document.getElementById('ab-caja2-msg');
    if (!box){
      box = document.createElement('div');
      box.id = 'ab-caja2-msg';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;max-width:92%;background:#111;color:#fff;padding:14px 18px;border-radius:10px;font-weight:600;font-size:15px;line-height:1.35;text-align:center;box-shadow:0 8px 24px rgba(0,0,0,.3);';
      document.body.appendChild(box);
    }
    box.textContent = textoCarrito(n);
    box.style.display = 'block';
    clearTimeout(showMsg._t);
    showMsg._t = setTimeout(function(){ box.style.display = 'none'; }, 7000);
  }

  /* Se bloquea con el último conteo leído, sin volver a hacer clic por código:
     ab-min-3.js ya detiene el clic, revisa el carrito y lo repite; si aquí también
     se repitiera, los dos scripts se pasarían el clic sin fin. */
  function actualizarConteo(){ fetchCajas().then(function(n){ if (n !== null) cajas = n; }); }

  document.addEventListener('click', function(e){
    refreshSoon(700);
    var path = e.composedPath ? e.composedPath() : [e.target];
    var hit = false;
    for (var i = 0; i < path.length; i++){
      if (path[i] === document.body) break;
      if (isCheckoutEl(path[i])){ hit = true; break; }
    }
    if (!hit || cumple(cajas)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showMsg(cajas);
  }, true);

  document.addEventListener('change', function(){ actualizarConteo(); refreshSoon(700); }, true);
  document.addEventListener('submit', function(){ setTimeout(actualizarConteo, 900); refreshSoon(900); }, true);

  function init(){ avisoFicha(); actualizarConteo(); refrescarCarrito(); }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setInterval(refrescarCarrito, 4000);
})();
